module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5e8ae4f197c277184f9dd255db7abf53.png";